import { render, staticRenderFns } from "./InterconsultaView.vue?vue&type=template&id=9ef2f118&scoped=true"
import script from "./InterconsultaView.vue?vue&type=script&lang=js"
export * from "./InterconsultaView.vue?vue&type=script&lang=js"
import style0 from "./InterconsultaView.vue?vue&type=style&index=0&id=9ef2f118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef2f118",
  null
  
)

export default component.exports